import { OrderStateEnum } from '@bo-client/shared/models/orderRequestDto';
import { StatusDefinition } from '../status.model';

/** Wert `rejected` kommt im Status der Anfrage vor, fehlt aber in `OrderStateEnum`. */
export const ORDER_REQUEST_REJECTED = 'rejected';

/** Hausanschluss – Status der Anfrage (`OrderRequest.state`). */
export const ORDER_REQUEST_STATUS_DEFINITIONS: readonly StatusDefinition[] = [
  { value: OrderStateEnum.Created, defaultLabel: 'Angefragt', defaultColor: '#71dde3' },
  { value: OrderStateEnum.Placed, defaultLabel: 'Beauftragt', defaultColor: '#C3E88D' },
  { value: OrderStateEnum.CreatingSap, defaultLabel: 'Auftrag in Erstellung (SAP)', defaultColor: '#71dde3' },
  {
    value: OrderStateEnum.ConfirmationRequestedByMail,
    defaultLabel: 'Angebot per E-Mail versandt',
    defaultColor: '#f0b429'
  },
  { value: OrderStateEnum.Confirmed, defaultLabel: 'Angebot bestätigt', defaultColor: '#f0b429' },
  {
    value: OrderStateEnum.ErrorCreatingOrder,
    defaultLabel: 'Fehler bei der Auftragsanlage',
    defaultColor: '#fd7e14'
  },
  { value: OrderStateEnum.Approved, defaultLabel: 'Freigegeben', defaultColor: '#C3E88D' },
  { value: OrderStateEnum.UnderConstruction, defaultLabel: 'Im Bau', defaultColor: '#C3E88D' },
  { value: OrderStateEnum.InProgress, defaultLabel: 'In Bearbeitung', defaultColor: '#C3E88D' },
  {
    value: OrderStateEnum.TechnicallyCompleted,
    defaultLabel: 'Technisch abgeschlossen',
    defaultColor: '#e99aa6'
  },
  {
    value: OrderStateEnum.CommerciallyCompleted,
    defaultLabel: 'Kaufmännisch abgeschlossen',
    defaultColor: '#e99aa6'
  },
  { value: ORDER_REQUEST_REJECTED, defaultLabel: 'Abgelehnt', defaultColor: '#fd7e14' },
  { value: OrderStateEnum.Canceled, defaultLabel: 'Storniert', defaultColor: '#e99aa6' }
];
